<template>
    <div class="head-sticky">
        <div class="head-bg" :class="{'black-bg': isScrolled || navStatus || qrPanelOpen, 'en': locale == 'en-US'}">
            <!-- {{ activeNavId }} -->
            <div class="wrap">
                <nuxt-link class="logo" :to="localePath('/')" @click="toHome">
                    <img :src="logoImg" :alt="t('common.logoAlt')" v-if="logoImg">
                    <img src="@/assets/images/logo.png" :alt="t('common.logoAlt')" v-else>
                </nuxt-link>
                <div class="head-right flex justify-end font16">
                    <ViewOnMobile @panel-hover-change="onQrPanelChange"></ViewOnMobile>


                    <!-- <div class="header-search cursor" :class="{'is-open' : isOpen}" @click="searchOpen">
                        <span class="header-icon"><img src="@/assets/images/icon/icon-search.png" alt=""></span>
                    </div> -->
                    <!-- <div class="header-lang cursor" :class="{'is-open' : showLang}" @click="langOpen" @pointerleave="langClose">
                        <span class="header-icon"><img src="@/assets/images/icon/icon-lang.png" alt=""></span>
                        <div class="lang-box" :class="{'is-open' : showLang}">
                            <p><span :class="{'select':locale=='zh-CN'}" @click="changeLang('/zh-CN')">{{t('common.chinese')}}</span></p>
                            <p><span :class="{'select':locale=='en-US'}" @click="changeLang('/en-US')">{{t('common.english')}}</span></p>
                        </div>
                    </div> -->
                    <!-- <div class="header-login cursor">
                        <span class="header-icon"><img src="@/assets/images/icon/icon-user.png" alt=""></span>
                    </div> -->
                    <div class="head-menu" @click="mobileMenuPop=true"><span v-for="(item, index) in 3" :key="index"></span></div>
                </div>
                <SecondNav
                    :nav="nav"
                    :active-nav="activeNav"
                    :active-nav-id="activeNavId"
                    @nav-hover-change="onDesktopNavHover"
                    @link-click="toLink"
                    @show-msg="showmsg"
                />
            </div>
        </div>
    </div>
    
    <!-- 移动端菜单下拉（关闭时不挂载，避免 SSR/首屏无样式时露出菜单 DOM） -->
    <el-drawer
        v-model="mobileMenuPop"
        :z-index="2000"
        :show-close="false"
        direction="rtl"
        :size="mobileDrawerSize"
        class="mobile-menu-pop"
        :class="{'en': locale == 'en-US'}"
        :append-to-body="true"
    >
        <template #header="{ close, titleId, titleClass }">
            <div class="mobile-menu-close cursor" @click="close"><span v-for="(item, index) in 2" :key="index"></span></div>
        </template>
        <div class="mobile-menu">
            <el-menu
                class="mobile-menu-list"
                :unique-opened="true"
                :default-openeds="mobileMenuDefaultOpeneds"
            >
                <template
                    v-for="(item, index) in nav"
                    :key="item.id"
                >
                    <el-sub-menu
                        :index="item.id"
                        v-if="item.childrenList && item.childrenList.length"
                    >
                        <template #title>{{ item.name }}</template>
                        <el-menu-item
                            class="mobile-sub-list"
                            :class="{'hit': activeNavId[1] && value.id === activeNavId[1] }"
                            v-for="(value, index) in item.childrenList"
                            :key="index"
                            :index="value.id">
                            <nuxt-link
                                v-if="value.link!='#'"
                                :key="value.id"
                                @click="toLink(value)"
                                :to="localePath(value.link)"
                                :target="value.link.includes('http') ? '_blank' : ''"
                                :rel="value.link.includes('http') ? 'nofollow noopener noreferrer' : ''"
                            >{{value.name}}</nuxt-link>
                            <a v-else :key="value.id" @click="showmsg">{{item.name}}</a>
                        </el-menu-item>
                    </el-sub-menu>
                    <el-menu-item v-else :index="item.id">
                        <template v-if="item.link!='#'">
                            <nuxt-link
                                @click="toLink(item)"
                                :to="localePath(item.link)"
                                :target="item.link.includes('http') ? '_blank' : ''"
                                :rel="item.link.includes('http') ? 'nofollow noopener noreferrer' : ''"
                            >{{item.name}}</nuxt-link>
                        </template>
                        <template v-else>
                            <a @click="showmsg">{{item.name}}</a>
                        </template>
                    </el-menu-item>
                </template>
            </el-menu>
        </div>
    </el-drawer>
    <!-- 搜索框 -->
    <div v-if="isOpen" class="search-bg is-open" @mouseleave="searchClose">
        <div class="search-box flex-center">
            <Search @search="toSearch"></Search>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { findBuryKey, sendBuryClient, useLocalePath, useRuntimeConfig, useState } from '#imports'
    import { ref, onMounted, onUnmounted , watch, reactive, computed} from 'vue'
    import { ElMessage } from 'element-plus'
    import { useRouter,useRoute } from 'vue-router'
    import { formatDateToChineseMd,formatDate } from "@/utils/utils"
    import useServerRequest from '@/composables/useServerRequest'
    import type {WeatherParams, HeaderNavItem, configResponse ,CurrentCityResponse} from '~/types'
    import { useI18n } from 'vue-i18n' // 导入 useI18n
    const { locale,t } = useI18n() // 获取当前 i18n 语言（如 zh-CN/en-US）
    const config = useRuntimeConfig()
    const cmsurlStrategy = config?.public?.cmsStrategy

	const localePath = useLocalePath()
	const router = useRouter();
	const route = useRoute();
    import { getBrowserLngLat } from '~/utils/location';
    import {
        safeStorageGetJSON,
        safeStorageSetItem,
    } from '~/utils/safeLocalStorage';
    import SecondNav from '~/components/NavHeader/SecondNav.vue'
    import ViewOnMobile from '~/components/NavHeader/ViewOnMobile.vue'
	//判断进入页面地址
	const activeNav = ref("/");
	const pathArr = route.path.split("/");
	if(pathArr.length >= 2){
		activeNav.value = "/"+pathArr[1];
	}

    const toHome = () => {
        sendBuryClient({
            key: 'home_page__button',
            name: '首页',
            module: 'header',
        })
    }
    const toLink = (item:HeaderNavItem)=>{
        console.log(item, '111')
        sendBuryClient({
            key: `${item.eventKey || ''}__button`,
            name: item.name,
            module: 'header',
        })
        // if(item.link){
        //     //router.push(localePath(item.link))
        //     window.location.href=localePath(item.link)
        // }
	}
    const changeLang = (lang:string)=>{
        findBuryKey('language')
        safeStorageSetItem('from', 'zh-CN');
        window.location.href = lang
    }
    // 导航下拉（桌面二级导航悬停，由 SecondNav 同步）
    const navStatus = ref(0);
    const qrPanelOpen = ref(false)
    const onDesktopNavHover = (expanded: boolean) => {
        navStatus.value = expanded ? 1 : 0
    }
    const onQrPanelChange = (expanded: boolean) => {
        qrPanelOpen.value = expanded
    }

	
	//关键词	
    const toSearch = (keyword:string)=>{
        findBuryKey('search')
        router.push(localePath('/search?keyword='+keyword))
        isOpen.value = false
    }
    // 搜索
    const isOpen = ref(false);
    const searchOpen = ()=> {
        isOpen.value = !isOpen.value
        showLang.value = false
    }
    const searchClose = ()=>{
        isOpen.value = false
    }
    const handSearchClick = (event:any)=> {
        event.stopPropagation();
    }
    const site = ref({
		logo:""
	});

    // 语言
    const showLang = ref(false);
    const langOpen = ()=> {
        showLang.value = !showLang.value
        isOpen.value = false
    }
    const langClose = ()=>{
        showLang.value = false
    }

    // 移动端菜单
    const mobileMenuPop = ref(false)
	
    watch(() => route.path,
        (path: any) => {
			const arr = path.split("/");
			if(arr.length >= 2){
				activeNav.value = "/"+arr[1];
			}
			mobileMenuPop.value = false
			
        }
    );

    // header滚动
    const isScrolled = ref(false)
    const handleScroll = () => {
        isScrolled.value = window.scrollY > 0
    }

    // 获取导航配置
    const nav = useState<HeaderNavItem[]>('headNav', () => [])
    const logoImg = useState<string>('headLogo', () => '')
    const formatNav = (navList: any[], pId = ''):HeaderNavItem[] => {
        return navList.map((item, index) => ({
            id: pId ? `${pId}_${index}` : `${index}`,
            name: item.title,
            link: item.link,
            text: item.desc ?? '',
            image: item.image ?? '',
            childrenList: item.children?.length ? formatNav(item.children, pId ? `${pId}_${index}` : `${index}`) : [],
            eventKey: item.eventKey || ''
        }))
    }
    try {
        const { data: headerConfigData } = await useServerRequest<configResponse>(
            'COMMON_CONFIG-header',
            `${cmsurlStrategy}/getPageConfig`,
            {
                method: 'GET',
                params: {
                    pageCode: 'COMMON_CONFIG',
                },
                language: locale.value,
            },
        )
        const getInfoData = headerConfigData.value?.data?.pageValue
        const menuList = getInfoData?.header?.menuList
        // 仅在拿到有效配置时写入；避免客户端 payload/请求失败时把 SSR 导航清空
        if (Array.isArray(menuList) && menuList.length > 0) {
            nav.value = formatNav(menuList)
            logoImg.value = getInfoData?.header?.logo || logoImg.value
        }
    } catch {
        // 配置拉取失败时保留已有导航（含 SSR），避免阻塞页面渲染
    }
    const hasSelectCityCache = () => {
        const parsed = safeStorageGetJSON<{ id?: number; dataLanguage?: string }>('selectCity')
        return !!(parsed?.id && parsed?.dataLanguage === locale.value)
    }

    onMounted(async () => { 
        if(route.query.from){
            const from = route.query.from as string
            safeStorageSetItem('from', from)
        }
        // 已有城市缓存时由页面组件拉天气；无缓存时仅 Header 负责定位 + 国外跳转
        if (!hasSelectCityCache()) {
            void getBrowserLngLat()
                .then((ll) => {
                    weatherParams.lat = ll?.lat ?? ''
                    weatherParams.lon = ll?.lng ?? ''
                    return getCityData()
                })
                .catch(() => {})
        }
		//window.addEventListener('keydown', keyDown);
        window.addEventListener('scroll', handleScroll);
        handleScroll() // 手动触发一次
        // 监听touchstart事件
        document.addEventListener('touchstart', (e) => {
            // 如果操作的是lang-box，不关闭语言下拉
            if((e.target as HTMLElement).closest('.lang-box')){
                return
            }
            if(showLang.value){
                setTimeout(() => {
                    showLang.value = false
                }, 0);
            }
        });
    });
    
      //获取定位的城市信息
    const getCityData = async() =>{
        try {
            const { data } = await useServerRequest<CurrentCityResponse>('current-city-data', `${cmsurlStrategy}/getCityData`, { method: 'GET', params:weatherParams, language: locale.value })
            const currentcity = data?.value?.data?.city
            weatherParams.lat = ''
            weatherParams.lon = ''
            weatherParams.cityId = currentcity?.id

            // 暂不开放英文站：关闭国外 IP 自动跳转 en-US
            //setStorage('locationCity',currentcity)
        } catch {
        }
    }
    onUnmounted(() => {
		//window.removeEventListener('keydown', keyDown, false)
        window.removeEventListener('scroll', handleScroll);
    });
	// 点击回车键登录
	// const keyDown = (e:any) => {
	//   if ((e.keyCode === 13 || e.keyCode === 100) && isOpen.value == true) {
	// 	  toSearch();
	//   }
	// }
	//针对#做出导航提示
	const showmsg = ()=>{
		ElMessage({
			message: t("index.systemPrompt"),
			type: "warning",
			offset:120
		});
	}
    const weatherParams = reactive<WeatherParams>({
        lat: '',
        lon: ''
    })

    const getPurePath = () => {
        const path = route.path || ''
        // 去掉 /zh-CN /en-US 等
        return path.replace(/^\/[a-zA-Z-]+/, '')
    }
    const mobileDrawerSize = computed(() => (locale.value === 'en-US' ? '320px' : '190px'))

    const activeNavId = computed(():string[] => {
        if(!route) return []
        const path = getPurePath()
        for (const nav1 of nav.value) {
            // 先匹配子级
            if (nav1.childrenList?.length) {
                for (const nav2 of nav1.childrenList) {
                    if (path === nav2.link) {
                        return [nav1.id,nav2.id]
                    }
                }
            }
            // 再匹配父级
            if (path === nav1.link || path.startsWith(nav1.link + '/')) {
                return [nav1.id]
            }
        }
        return []
    })
    const mobileMenuDefaultOpeneds = computed(() => {
        const openId = activeNavId.value[0]
        return openId ? [openId] : []
    })
</script>
<style scoped lang="scss">
    .head-sticky{
        height: 0;
        position: sticky;
        z-index: 99;
        top: 0;
    }
    .head-bg{
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        height: 64px;
        z-index: 10;
        overflow: visible;
        &::before{
            display: block;
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-color: var(--color-neutral-01, #151b29);
            box-shadow: var(--layer-elevated-shadow);
            opacity: 1;
            visibility: visible;
            transition: all .3s;
            z-index: -1;
        }
        .logo{
            position: relative;
            flex-shrink: 0;
            float: left;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            transition: all .3s;
            height: 64px;
            padding-right: 21px;
            z-index: 1;
            cursor: pointer;
            img{
                display: block;
                width: 72px;
                height: 28px;
                max-width: none;
                max-height: none;
                object-fit: contain;
            }
        }
        .head-right{
            position: relative;
            float: right;
            height: 64px;
            text-align: right;
            font-size: 0;
            flex: auto;
            font-size: 16px;
            color: #332E2E;
            text-align: right;
            z-index: 1;
            align-items: center;
            .header-date{
                opacity: .5;
            }
            .header-search,
            .header-lang,
            .header-login{
                position: relative;
                margin-left: 30px;
                &.is-open{
                    .lang-box{
                        opacity: 1;
                        visibility: visible;
                        transform: translateX(-50%) scaleY(1);
                        .select{
                            color:var(--org-color);
                        }
                    }
                    .header-icon{
                        background-color: var(--org-color);
                        // border-radius: 4px;
                        transform: scale(1.5);
                        img{
                            transform: scale(0.7);
                            margin: 0 auto;
                        }
                    }
                }
            }
            .header-icon{
                display: block;
                width: 18px;
                height: 18px;
                transition: all .3s;
                img{
                    display: block;
                    width: 100%;
                    transition: all .3s;
                }
                &:hover{
                    background-color: var(--org-color);
                    // border-radius: 4px;
                    transform: scale(1.5);
                    img{
                        transform: scale(0.7);
                        margin: 0 auto;
                    }
                }
            }
            .header-lang{
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                height: 100%;
            }
            .lang-box{
                position: absolute;
                left: 50%;
                top: 100%;
                min-width: 72px;
                padding: 12px 0;
                background-color: var(--color-neutral-01, #151b29);
                box-shadow: var(--layer-elevated-shadow);
                text-align: center;
                opacity: 0;
                visibility: hidden;
                transform: translateX(-50%) scaleY(0);
                transform-origin: center top;
                transition: all .3s;
                p{
                    span{
                        display: block;
                        font-size: 12px;
                        color: #FFFFFF;
                        line-height: 26px;
                        transition: all .3s;
                        &:hover{
                            color: var(--org-color);
                        }
                    }
                }
            }
        }
        &.black-bg{
            &::before{
                opacity: 1;
                visibility: visible;
            }
        }
        @media (min-width:1201px){
            &.en{
                .logo{
                    // padding-bottom: 8px;
                    img{
                        max-height: 28px;
                    }
                }
                :deep(.nav-list){
                    > li{
                        > a{
                            line-height: 55px;
                            padding-top: 5px;
                        }
                    }
                }
            }
        }
    }

    // 移动端导航菜单
    .head-menu{
        display: none;
    }
    .mobile-menu-pop{
        .mobile-menu-close{
            position: relative;
            width: 20px;
            height: 20px;
            margin: 23px 15px;
            margin-left: auto;
            transition: all .3s linear;
            span{
                display: block;
                width: 100%;
                height: 2px;
                background: #FFFFFF;
                position: absolute;
                left: 0;
                top: calc((100% - 4px) / 2);
                transition: all .3s;
                &:nth-child(1) {
                    transform: translateY(0) rotate(45deg);
                }

                &:nth-child(2) {
                    transform: translateY(0) rotate(-45deg);
                }
            }
            &:hover{
                opacity: .8;
                transform: rotate(90deg);
            }
        }
        .mobile-menu{
            .el-menu{
                border: none;
                background-color: transparent;
                --el-menu-active-color: #FFFFFF;
                --el-menu-bg-color: transparent;
            }
            .el-menu-item{
                display: block;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                --el-menu-item-height: 44px;
                --el-menu-sub-item-height: 36px;
                padding-left: var(--el-menu-base-level-padding) !important;  // 强制不允许菜单缩进
                &.hit{
                    a{
                        color: var(--org-color);
                    }
                    &:hover{
                        background: transparent;
                        backdrop-filter: none;
                    }
                }
                &:hover{
                    background: transparent;
                    color: #FFFFFF;
                    background: rgba(36,44,62,0.5);
                    backdrop-filter: blur(10px);
                }
                > a{
                    display: block;
                    color: #FFFFFF;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                &.mobile-sub-list{
                    padding-right: 44px;
                    > a{
                        font-size: 12px;
                        opacity: .75;
                    }
                    &:not(.hit):hover{
                        color: #FFFFFF;
                        background: rgba(36,44,62,0.5);
                        backdrop-filter: blur(10px);
                        // background-image: url('@/assets/images/icon/icon-nav.webp');
                        // background-position: right 24px center;
                        // background-repeat: no-repeat;
                        // background-size: 16px auto;
                    }
                }
            }
            :deep(.el-sub-menu__title){
                height: 44px;
                color: #FFFFFF;
                line-height: 44px;
                span{
                    flex: auto;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }    
                &:hover{
                    background: transparent;
                    color: #FFFFFF;
                    background: rgba(36,44,62,0.5);
                    backdrop-filter: blur(10px);
                }
                .el-icon{
                    svg{
                        width: 1.4em;
                        height: 1.4em;
                    }
                }
            }
            :deep(.el-sub-menu){
                &.is-opened{
                    > .el-sub-menu__title{
                        color: #FFFFFF;
                        background: rgba(36,44,62,0.5);
                        backdrop-filter: blur(10px);
                    }
                }
            }
        }
        &.en{
            .mobile-menu{
                .el-menu-item{
                    &.mobile-sub-list{
                        padding-right: 24px;
                    }
                }
            }
        }
    }

    // 搜索框
    .search-bg{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 348px;
        padding: 60px 20px;
        background: rgba(36,44,62,0.5);
        backdrop-filter: blur(10px);
        opacity: 0;
        visibility: hidden;
        transform: scaleY(0);
        transform-origin: center top;
        transition: all .3s;
        z-index: 2;
        &.is-open{
            opacity: 1;
            visibility: visible;
            transform: scaleY(1);
        }
        .search-box{
            max-width: 483px;
            height: 100%;
            margin: 0 auto;
        }
    }

    @media (max-width:1400px){
        .head-bg{
            .head-right{
                font-size: 15px;
            }
        }

    }
    @media (max-width:911px){
        .head-bg{
            .wrap{
                padding: 0 32px;
            }
        }
        .head-menu{
            display: block;
            position: relative;
            width: 18px;
            height: 18px;
            margin-left: 16px;
            text-align: center;
            cursor: pointer;
            overflow: hidden;
            background: url('@/assets/images/icon/icon-menu.png') center center no-repeat;
            background-size: contain;
            span{
                display: none;
                position: absolute;
                left: 0;
                right: 0;
			    top: calc((100% - 2px) / 2);
                width: 100%;
                height: 2px;
                background-color: #FFFFFF;
                margin: 0 auto;
                &:nth-child(1) {
                    transform: translateY(10px) rotate(0deg);
                }
                &:nth-child(3) {
                    transform: translateY(-10px) rotate(0deg);
                }
            }
        }
    }
    @media (max-width:991px){

    }
    @media (max-width:750px){
        .head-bg{
            .wrap{
                padding: 0 16px;
                // 顶部宽度？？ padding: 0 32px;
            }
        }
        .head-bg{
            height: 64px;
            .logo{
                height: 64px;
            }
            
            .head-right{
                height: 64px;
                .header-search,
                .header-lang,
                .header-login{
                    margin-left: 15px;
                }
            }
        }
        .head-menu{
            width: 18px;
            height: 18px;
            margin-left: 16px;
            overflow: hidden;
            span{
                height: 1px;
                &:nth-child(1){
                    transform: translateY(6px) rotate(0deg);
                }
                &:nth-child(3){
                    transform: translateY(-6px) rotate(0deg);
                }
            }
        }

    }
    @media (max-width:640px){
        .head-bg{
            .head-right{
                .header-date{
                    display: none;
                }
            }
        }
    }
    @media (max-width:460px){

    }
</style>
<style lang="scss">
    .mobile-menu-pop.el-drawer {
        --el-menu-base-level-padding: 24px;
        background-color: rgba(36, 44, 62, 0.96) !important;
        backdrop-filter: blur(10px);
        -webkit-transform: translateZ(0);
        transform: translateZ(0);

        .el-drawer__header {
            display: block;
            padding: 0;
            margin: 0;
        }
        .el-drawer__body {
            padding: 0;
            background-color: transparent;
        }
        &.en {
            --el-menu-base-level-padding: 16px;
        }
    }
</style>